import {
  createDefaultBankedProfile,
  migrateBankedProfile,
  migrateRunSave,
  type BankedProfile,
  type RunSave,
} from "../simulation/persistence";

const BANKED_KEY = "zonevelocity.banked.v1";
const RUN_KEY = "zonevelocity.run.v1";
const IDENTITY_KEY = "zonevelocity.identity.v1";

export type LocalIdentity = {
  kind: "anonymous";
  id: string;
};

/** Local-first banked profile + mid-run save. Works with no backend. */
export class LocalProfileStore {
  public loadBanked(): BankedProfile {
    try {
      const raw = localStorage.getItem(BANKED_KEY);
      if (!raw) return createDefaultBankedProfile();
      return migrateBankedProfile(JSON.parse(raw));
    } catch {
      return createDefaultBankedProfile();
    }
  }

  public saveBanked(profile: BankedProfile): void {
    localStorage.setItem(BANKED_KEY, JSON.stringify(profile));
  }

  public loadRun(): RunSave | null {
    try {
      const raw = localStorage.getItem(RUN_KEY);
      if (!raw) return null;
      return migrateRunSave(JSON.parse(raw));
    } catch {
      return null;
    }
  }

  public saveRun(save: RunSave): void {
    localStorage.setItem(RUN_KEY, JSON.stringify(save));
  }

  public clearRun(): void {
    localStorage.removeItem(RUN_KEY);
  }

  public getOrCreateIdentity(): LocalIdentity {
    try {
      const raw = localStorage.getItem(IDENTITY_KEY);
      if (raw) return JSON.parse(raw) as LocalIdentity;
    } catch {
      // fall through
    }
    const identity: LocalIdentity = {
      kind: "anonymous",
      id: `anon_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`,
    };
    localStorage.setItem(IDENTITY_KEY, JSON.stringify(identity));
    return identity;
  }
}
